import styled from '@emotion/styled'
import React from 'react'
import { Headline } from './Headline'

type ReadMoreProps = {
    readTime: number | null
    className?: string
}

export const ReadMore = ({ readTime, className }: ReadMoreProps) => (
    <ReadMoreStyled className={className}>{`Read more${
        readTime ? ` (${Math.ceil(readTime)} min)` : ''
    } →`}</ReadMoreStyled>
)

const ReadMoreStyled = styled.div(({ theme }) => ({
    alignSelf: 'flex-end',
    fontFamily: theme.fonts.sansSerif,
    fontSize: 16,
    textDecoration: 'underline',
    color: theme.colors.text.tertiary,
}))
